import { alertRequestWait } from "../../Modules/Kernel/Assets/util";

/**
 * DON'T EXPORT FROM HERE AS THIS WILL BIND LISTENERS MULTIPLE TIMES
 */

$(document).ajaxError(function (event, jqxhr, settings, exception) {
  var currentUrl = window.location.pathname;

  if (exception == "Unauthorized" && !currentUrl.includes("public")) {
    let location = window.location.origin + "/auth/login";
  }
});

$(document).ready(function () {

  function checkboxDescriptionLogic(element) {
    if($(element).is(":checked")) {
      $(element).parent().find("p").removeClass("not-checked");
      $(element).parent().find("p").addClass("checked");
    } else {
      $(element).parent().find("p").removeClass("checked");
      $(element).parent().find("p").addClass("not-checked");
    }
  }

  checkboxDescriptionLogic($(".checkbox-description input"));

  $(document).on("change", ".checkbox-description input", function() {
    checkboxDescriptionLogic($(this));
  });

  $('.workforce-roster-location').select2({
    width: "264px",
    templateResult: function (data) {    
      // We only really care if there is an element to pull classes from
      if (!data.element) {
        return data.text;
      }
  
      var $element = $(data.element);
  
      var $wrapper = $('<span></span>');
      $wrapper.addClass($element[0].className);
  
      $wrapper.text(data.text);
  
      return $wrapper;
    }
  });

  $(".select-2-container select").select2({
    width: "100%",
  });

  $(".dropdown ul a").on("click", function(event) {
    if($(this).attr("href") == "") {
      event.preventDefault();
    }
  });

  //$("#other-branches").chosen();
  var currentSelectedPrimaryBranch = $("#primary-branch").val();
  $("#primary-branch").empty().trigger("change");

  $("#primary-branch").attr("data-placeholder", "Please select a branch");
  $("#primary-branch").select2();

  $("#other-branches option:selected").each(function (i, e) {
    console.log(e);
    var optionValue = $(this).val();
    var optionLabel = $(this).text();

    console.log(optionLabel);

    var newPrimaryBranchOption =
      '<option value="' + optionValue + '">' + optionLabel + "</option>";
    $("#primary-branch").append(newPrimaryBranchOption);
    $("#primary-branch").trigger("change");
  });

  $("#primary-branch").val(currentSelectedPrimaryBranch);
  $("#primary-branch").trigger("change");

  $("#other-branches").on("select2:select", function (e) {
    var data = e.params.data;
    var optionValue = data.id;
    var optionLabel = data.text;

    var newPrimaryBranchOption =
      '<option value="' + optionValue + '">' + optionLabel + "</option>";
    $("#primary-branch").append(newPrimaryBranchOption);
    //$("#primary-branch").removeAttr('disabled');

    var element = e.params.data.element;
    var $element = $(element);

    $element.detach();
    $(this).append($element);
    $(this).trigger("change");
  });

  $("#other-branches").on("select2:unselect", function (e) {
    var data = e.params.data;
    var optionValue = data.id;

    $("#primary-branch option[value='" + optionValue + "']").remove();
    $("#primary-branch").select2().trigger("change");

    // var branchCount = $("#primary-branch option").length;

    // if(branchCount == 1) {
    // 	$("#primary-branch").prop('disabled', true);
    // 	$('#primary-branch').select2().trigger('change');
    // }
  });

  $("#fetch-profile").click(function (event) {
    let email = $("#fetch-profile-email").val();
    $.ajax({
      method: "GET",
      url: "/admin/users/" + email + "/fetch-profile",
    })
      .done((res) => {
        window.location = res.data.user_creation_link;
      })
      .fail((err) => {
        let message = JSON.parse(err.responseText);
        $.alert({
          theme: "custom",
          title: message.data.title,
          content: message.data.description,
          animateFromElement: false,
          buttons: {
            close: {
              btnClass: "button-primary",
              text: "Okay",
            },
          },
        });
      });
  });

  //SETTINGS
  // $.ajax({
  // 	method:"GET",
  // 	url:"/admin/setting/fetch-all"

  // }).done(function(res){
  // 	window.setting = res.data.setting;
  // })

  //select 2 init
  $(".login-page select").select2({
    width: "style",
  });

  $(".individual-member").select2();
  $("#qualifications-filter").select2();
  $("#roles").select2();
  $("#groups_third_level").select2({tags: true});

  //inject token into all ajax from this file
  $.ajaxSetup({
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
    dataType: "text",
    dataFilter: function (data) {
      try {
        var data = JSON.parse(data);
        return data;
      } catch (error) {
        return data;
      }
    },
  });

  //select 2 auto compelete.
  // $('select').select2({
  // 	 placeholder: $(this).attr('data-placeholder'),
  // });

  $(".chosen").change(function () {
    if ($(".chosen option:selected").val() == "all") {
      $(".chosen > option").each(function () {
        $(this).val() == "all"
          ? $(this).prop("selected", false)
          : $(this).prop("selected", "selected");
      });

      //Because of a possible bug in the library. Have to do it on background thread not on main
      setTimeout(function () {
        $(".chosen").trigger("change");
      }, 0);

      //$(".chosen").trigger("change");
    }
  });

  // $(".create-message, .draft-message").click(function(event) {

  // 	event.preventDefault();

  // 	var maxFileSize = 55;

  // 	var maxFileSizeTumbnail = 5;

  // 	var title = $("#title").val();

  // 	var body = $("#body").val();

  // 	var template = $("#content_template_component").val();

  // 	var messageCreationErrorMessage = [];

  // 	if($.trim(title) == ""){
  // 		messageCreationErrorMessage.push("The title field is required");
  // 	}

  // 	if($.trim(body) == ""){
  // 		messageCreationErrorMessage.push("The body field is required");
  // 	}

  // 	if($.trim(template) == ""){
  // 		messageCreationErrorMessage.push("The template field is required");
  // 	}

  // 	var type = $("#type").val();

  // 	if(type == "text_attachment" ||
  // 		type == "image" ||
  // 		type == "audio" ||
  // 		type == "video"
  // 	){
  // 		var showField = '.type-'+type;
  //         var uploadAttachmentFile  = $(showField + ' .attachment-upload').prop('files');

  // 		if ((uploadAttachmentFile[0].size / 1000000) > maxFileSize) {
  // 				messageCreationErrorMessage.push("File attachment too big, please reduce the file size and try again");
  // 		}
  // 	}

  // 	if(type == "video"){
  // 		var attachmentThumbnail  = $('.video-thumb').prop('files');

  // 		if ((attachmentThumbnail[0].size / 1000000) > maxFileSizeTumbnail) {
  // 				messageCreationErrorMessage.push("File attachment thumbnail too big', please reduce the file size and try again(max 5 MB)");
  // 		}
  // 	}

  // 	if(messageCreationErrorMessage.length !== 0){

  // 		var errorMessage = "";
  // 		for(i = 0 ; i < messageCreationErrorMessage.length ; i++ ){
  // 			errorMessage = errorMessage + messageCreationErrorMessage[i] + "<br/>";
  // 		}
  // 		$.alert({
  // 			theme: 'custom',
  // 			title: 'Message Field Errors',
  // 			animateFromElement: false,
  // 			content: errorMessage,
  // 			buttons: {
  // 				close: {
  // 					btnClass: 'button-primary',
  // 					text: 'Okay'
  // 				}
  // 			}
  // 		});
  // 	}else{
  // 		$("form").submit();
  // 	}
  // });

  var messageIsPublic = "This message is public";
  var messageIsNotPublic = "This message is not public";
  var messageLoadingLink = "loading URL...";
  var passcodeLoadingLink = "loading passcode...";
  var messageNoLink = "No URL generated";
  var passcodeNotAvailable = "No Passcode generated";
  var messageServerError = "something went wrong";
  var tagMessage = "Category: ";
  var passcode = "Passcode: ";
  var url = "URL: ";

  $(".make-public").click(function () {
    $.confirm({
      theme: "custom",
      title: "Manage Access",
      animateFromElement: false,
      closeIcon: true,
      content:
        "" +
        '<div class="report-link-wrapper">' +
        '<p class="error">  </p>' +
        '<p class="is-public"></p>' +
        '<p id="report-link">' +
        messageLoadingLink +
        "</p>" +
        '<p id="passcode">' +
        passcodeLoadingLink +
        "</p>" +
        '<p id="tag"></p>' +
        // '<button type="submit" id="enable-public-access" name="enable-public-access" class="btn">Create Unique Access </button>' +
        '<button type="submit" id="associate-with-tag" name="associate-with-tag" class="btn">Associate With Category</button>' +
        // '<button type="submit" id="remove-public-access" name="remove-public-access" class="btn">Remove Access </button>'+
        // '<button type="submit" id="generate-new-passcode" name="generate-new-passcode" class="btn">Generate New Passcode </button>'+
        '<input type="hidden" value="" id="uuid" />' +
        "</div>",
      buttons: {
        save: {
          text: "Close",
          btnClass: "button-primary button-ok-manage-access",
          action: function () {},
        },
      },
      onContentReady: function () {
        var typeID = $("#message_id_old").val();
        $.ajax({
          method: "GET",
          url: "/admin/access-link/message/" + typeID,
        })
          .done(function (data) {
            if (data.type == "error") {
              $(".is-public").html(messageIsNotPublic);
              $("#report-link").html(messageNoLink);
              $("#passcode").html(passcodeNotAvailable);
              $("#remove-public-access").hide();
              $("#generate-new-passcode").hide();
            } else {
              $("#report-link").html("");
              if (data.type_id == typeID) {
                //public
                $(".is-public").html(messageIsPublic);
                $("#report-link").html(url + data.link);
                $("#passcode").html(passcode + data.passcode);
                $("#tag").html(tagMessage + data.tag);
                $("#uuid").val(data.UUID);
                $("#enable-public-access").hide();
                $("#associate-with-tag").hide();
              } else {
                //not public
                $(".is-public").html(messageIsNotPublic);
                $("#remove-public-access").hide();
                $("#generate-new-passcode").hide();
              }
            }
          })
          .fail(function (error) {
            console.log(error);
          })
          .always(function () {
            $(".button-ok-manage-access").attr("disabled", false);
          });
      },
      onOpenBefore: function () {
        $(".button-ok-manage-access").attr("disabled", true);
      },
    });
  });

  $(document).on("click", "#remove-public-access", function (event) {
    var uuid = $("#uuid").val();
    var oldLink = $("#report-link").html();
    var oldPasscode = $("#passcode").html();

    $("#report-link").html(messageLoadingLink);
    $("#passcode").html(passcodeLoadingLink);
    $(".error").html("");

    $.ajax({
      method: "POST",
      url: "/admin/access-link/message/private/" + uuid,
    })
      .done(function (data) {
        if (data.type == "error") {
          $(".error").html(data.description);
        } else {
          $(".is-public").html(messageIsNotPublic);
          $("#report-link").html(url + messageNoLink);
          $("#passcode").html(passcode + passcodeNotAvailable);
          $("#tag").html(tagMessage + "NA");
          $("#remove-public-access").hide();
          $("#generate-new-passcode").hide();
          $("#enable-public-access").show();
          $("#associate-with-tag").show();

          $("#uuid").val("");
        }
      })
      .fail(function (error) {
        $("#report-link").html(oldLink);
        $("#passcode").html(oldPasscode);
        $(".error").html(messageServerError);
      });
  });

  $(document).on("click", "#enable-public-access", function (event) {
    var typeID = $("#message_id_old").val();
    var oldLink = $("#report-link").html();
    var oldPasscode = $("#passcode").html();
    $("#report-link").html(messageLoadingLink);
    $("#passcode").html(passcodeLoadingLink);
    $(".error").html("");

    $.ajax({
      method: "POST",
      url: "/admin/access-link/message/public/" + typeID,
    })
      .done(function (data) {
        if (data.type == "error") {
          $(".error").html(data.description);
        } else {
          $("#report-link").html(url + data.link);
          $(".is-public").html(messageIsPublic);
          $("#passcode").html(passcode + data.passcode);
          $("#tag").html(tagMessage + data.tag);
          $("#enable-public-access").hide();
          $("#associate-with-tag").hide();
          $("#remove-public-access").show();
          $("#generate-new-passcode").show();

          $("#uuid").val(data.UUID);
        }
      })
      .fail(function (error) {
        $("#report-link").html(oldLink);
        $("#passcode").html(oldPasscode);
        $(".error").html(messageServerError);
      });
  });

  $(document).on("click", "#associate-with-tag", function (event) {
    var typeID = $("#message_id_old").val();
    var oldLink = $("#report-link").html();
    var oldPasscode = $("#passcode").html();
    $("#report-link").html(messageLoadingLink);
    $("#passcode").html(passcodeLoadingLink);
    $(".error").html("");

    $.ajax({
      method: "POST",
      url: "/admin/access-link/tag/message/public/" + typeID,
    })
      .done(function (data) {
        if (data.type == "error") {
          $(".error").html(data.description);
        } else {
          $("#report-link").html(url + data.link);
          $(".is-public").html(messageIsPublic);
          $("#passcode").html(passcode + data.passcode);
          $("#tag").html(tagMessage + data.tag);
          $("#enable-public-access").hide();
          $("#associate-with-tag").hide();
          $("#remove-public-access").show();
          $("#generate-new-passcode").show();

          $("#uuid").val(data.UUID);
        }
      })
      .fail(function (error) {
        $("#report-link").html(oldLink);
        $("#passcode").html(oldPasscode);
        $(".error").html(messageServerError);
      });
  });

  $(document).on("click", "#generate-new-passcode", function (event) {
    var typeID = $("#message_id_old").val();
    var uuid = $("#uuid").val();
    var oldPasscode = $("#passcode").html();

    $("#passcode").html(passcodeLoadingLink);
    $(".error").html("");

    $.ajax({
      method: "POST",
      url: "/admin/access-link/message/passcode/" + uuid,
    })
      .done(function (data) {
        if (data.type == "error") {
          $(".error").html(data.description);
        } else {
          $("#passcode").html(passcode + data.passcode);
        }
      })
      .fail(function (error) {
        $("#passcode").html(oldPasscode);
        $(".error").html(messageServerError);
      });
  });

  // $(document).on( "click" , "#generate-new-public-link" ,function(event){

  // 	var typeID = $("#message_id").val();
  // 	var oldLink = $("#report-link").html();
  // 	$("#report-link").html(messageLoadingLink);
  // 	$(".error").html("");

  // 	$.ajax({
  // 		method:"POST",
  // 		data: {type_id: typeID },
  // 		url:"/admin/access-link/message",
  // 	}).done(function(data){
  // 		if(data.type == "error"){
  // 			$(".error").html(data.description);
  // 		}else{
  // 			$("#report-link").html(data.link);
  // 			$(".is-public").html(messageIsPublic);
  // 		}
  // 	}).fail(function(error) {
  // 		$("#report-link").html(oldLink);
  // 		$(".error").html(messageServerError);
  // 	});
  // });

  $("#test-notification").click(function () {
    $.ajax({
      method: "GET",
      url: "/admin/notification/test/" + $(this).data("user-uuid"),
    })
      .done(function (data) {
        console.log(data);
      })
      .fail(function (err) {
        console.log(err);
      });
  });

  //Dashboard Recently Submitted Communication Product
  // $('.recent-submission-item-inner .card').click(function(){
  // 	var id = $(this).attr('data-id');

  // 	//swap main content
  // 	$('.quick-content').hide();
  // 	$('.quick-content').removeClass('active-quick-content');
  // 	$('.quick-content#'+id).show();
  // 	$('.quick-content#'+id).addClass('active-quick-content');

  // });

  //checkbox CSS Level FIX

  $(".checkbox").each(function () {
    let level = $(this).data("level");
    let margin = level * 15;
    $(this).css("margin-left", margin);

    //console.log("dd");
  });

  //if submit group select == 0 then don't allow form to submit
  // $("#group").click(function(event){
  // 	event.preventDefault();
  // 	var atLeastOneIsChecked = false;
  // 	$(".checkbox_group_submit_groups").find("input").each(function(){

  // 		if($(this).is(":checked") === true){
  // 			atLeastOneIsChecked = true;
  // 			return false;
  // 		}
  // 	})

  // 	if(atLeastOneIsChecked){
  // 		$('#group').unbind('submit').submit();
  // 	}else{
  // 		alert("Need to select atleast one submit group");
  // 	}

  // })

  //edit link behaviour
  $("a.quick-edit-link").click(function () {
    //get id from current active card
    var id = $(".recent-submission-item-active").attr("data-id");
    window.location = "/admin/contents/" + id + "/edit";
  });

  //move to trash
  $("a.quick-trash-link").click(function () {
    var id = $(".recent-submission-item-active").attr("data-id");
    $.ajax({
      method: "POST",
      url: "contents/trash/" + id,
    }).done(function (data) {
      //refresh
      var json = jQuery.parseJSON(data);
      if (json.success === true) {
        location.reload();
      } else {
        console.log(json);
      }
    });
  });

  // $('a.admin-dropdown-menu-link').click(function(){
  // 	window.location = $(this).attr('href');
  // });

  //group indentation
  $(".group-item").each(function (index, element) {
    let data = $(this).data("level");
    data = (parseInt(data) + 1) * 15; //because level 0 is alligned to 10px padding

    //$(this).css("padding-left", function(){
    //return data;
    //});

    //$(this).css("padding-top", function(){
    //return 10;
    //});
  });

  $("#weight").one("click", show_weight);

  hideWeight();

  function show_weight() {
    $(this).text("Save weight");
    let list = $(".group-item").find("li");
    list.each(function (index, element) {
      var weight = $(element).find(".weight");
      weight.show();
    });

    $("#weight").one("click", hide_weight);
  }

  function hide_weight() {
    $(this).text("Edit weight");
    $("#weight").one("click", show_weight);
    let list = $(".group-item").find("li");
    list.each(function (index, element) {
      var weight = $(element).find(".weight");
      weight.hide();
    });
    reorderByWeight();
  }

  function hideWeight() {
    let list = $(".group-item").find("li");
    list.each(function (index, element) {
      var weight = $(element).find(".weight");
      weight.hide();
    });
  }

  $("#reorder-").click(function (event) {
    event.preventDefault();
    let url = kernel.url + "/reorder";
    reorder(url);
  });

  // function reorder(url){

  // 	weightArray = [];

  // 	$(".weight").each(function(index,element){
  // 		weightObj = $(this)

  // 		weight = weightObj.val();

  // 		id = weightObj.data("groupid");

  // 		weightHashMap = {};
  // 		weightHashMap.id = id;
  // 		weightHashMap.weight =weight;
  // 		weightArray.push(weightHashMap);

  // 	});

  // 	var _token = $('input[name="_token"]').val();
  // 	$.ajax({
  // 		method:"PUT",
  // 		url:url,
  // 		data:{_token : _token, groups:weightArray}

  // 	}).done(function(data){
  // 		//refresh

  // 		if(data.success == true){
  // 			location.reload();
  // 		} else{
  // 			console.log(data);
  // 		}

  // 	})
  // }
  function reorderByWeight() {
    let list = $(".group-item").find("li");
    let weightArray = [];
    list.each(function (index, element) {
      var weight = $(element).find(".weight");
      let id = weight.data("groupid");

      weight = weight.val();
      weightHashMap = {};
      weightHashMap.id = id;
      weightHashMap.weight = weight;

      weightArray.push(weightHashMap);
    });

    var _token = $('input[name="_token"]').val();
    let url = kernel.url + "/reorder";

    $.ajax({
      method: "PUT",
      url: url,
      data: { _token: _token, groups: weightArray },
    }).done(function (data) {
      if (data.success == true) {
      } else {
      }
    });
  }

  function reorder() {
    let weightArray = processAndSaveSortableList();

    var _token = $('input[name="_token"]').val();
    let url = $("#reorder-url").val();

    $.ajax({
      method: "PUT",
      url: url,
      data: { _token: _token, groups: weightArray },
    }).done(function (data) {
      console.log(data);
      if (data.success == true) {
      } else {
      }
    });
  }

  setSortableEventListener();
  setSortableStatus("disable");

  $("#reorder").one("click", reorder_allow_drag_and_drop_handler);

  function reorder_allow_drag_and_drop_handler(event) {
    event.preventDefault();
    setSortableStatus("enable");
    $(this).text("Save Reorder");
    $("#reorder").one("click", reorder_save_drag_and_drop_handler);
  }

  function reorder_save_drag_and_drop_handler(event) {
    event.preventDefault();
    setSortableStatus("disable");
    $(this).text("Enable Reorder");

    reorder();

    $("#reorder").one("click", reorder_allow_drag_and_drop_handler);
  }

  function setSortableStatus(status) {
    let is_sortable_level_1 = $("ul").hasClass("sortable-level-1");
    if (is_sortable_level_1) {
      sortable(".sortable-level-1", status);
    }

    let is_sortable_level_2 = $("ul").hasClass("sortable-level-2");
    if (is_sortable_level_2) {
      sortable(".sortable-level-2", status);
    }

    let is_sortable_level_3 = $("ul").hasClass("sortable-level-3");
    if (is_sortable_level_3) {
      sortable(".sortable-level-3", status);
    }
  }

  function setSortableEventListener() {
    let is_sortable_level_1 = $("ul").hasClass("sortable-level-1");
    if (is_sortable_level_1) {
      sortable(".sortable-level-1", {});
      // sortable('.sortable-level-1')[0].addEventListener('sortupdate', function(e) {
      // 	weightArray = processSortableList(e);
      // });
    }

    let is_sortable_level_2 = $("ul").hasClass("sortable-level-2");
    if (is_sortable_level_2) {
      sortable(".sortable-level-2", {});
      // sortable('.sortable-level-2')[0].addEventListener('sortupdate', function(e) {
      // 	weightArray = processSortableList(e);
      // });
    }

    let is_sortable_level_3 = $("ul").hasClass("sortable-level-3");
    if (is_sortable_level_3) {
      sortable(".sortable-level-3", {});

      // sortable('.sortable-level-3')[0].addEventListener('sortupdate', function(e) {
      // 	weightArray = processSortableList(e);
      // });
    }
  }

  function processAndSaveSortableList() {
    let list = $(".group-item").find("li");

    let weightArray = [];
    list.each(function (index, element) {
      var weight = $(element).find(".weight");
      let id = weight.data("groupid");

      weight = index;
      weightHashMap = {};
      weightHashMap.id = id;
      weightHashMap.weight = weight;

      weightArray.push(weightHashMap);
    });

    return weightArray;
  }

  $("#update-word-list").click(function (event) {
    event.preventDefault();

    var word = $('input[name="add_words"]').val();
    var _token = $('input[name="_token"]').val();
    var wordsDictSelected = [];
    var wordsDictOrig = [];

    $("option").each(function () {
      if ($(this).is(":selected")) {
        var selectedWords = $(this).val();
        wordsDictSelected.push(selectedWords);
      }

      wordsDictOrig.push($(this).val());
    });

    $.ajax({
      method: "POST",
      url: "filterwords",
      data: { _token: _token, word: word, wordLists: wordsDictSelected },
    }).done(function (data) {
      location.reload();
    });
  });

  //register page - I belong to multiple group
  $("#is-multiple-group").val($("#is-multiple-group").is(":checked"));
  if ($("#is-multiple-group").val() == "true") {
    $(".multiple-group").show();
  } else {
    $(".multiple-group").hide();
  }
  $("#is-multiple-group").change(function (event) {
    $(".multiple-group").toggle(this.checked);
    $(this).val(this.checked);
  });

  //Content form type selection
  var content_form_show_type_field = function () {
    var value = $(".content-form select#type").val();
    //console.log($('.content-form select#type').val());
    //$('.opt-fields').hide();
    $(".type-" + value).show();
  };
  //init
  content_form_show_type_field();
  //on change
  $(".content-form select#type").change(function () {
    content_form_show_type_field();
  });

  //datepickers
  $(".datepicker").each((index, element) => {
    const $ele = $(element);
    let options = {
      dateFormat: "d M yy",
    };
    if ($ele.val() !== "") options.defaultDate = new Date($ele.val());
    $ele.datepicker(options);
  });

  //timepickers
  timepickerInit($(".timepicker"));
  //datetimepickers
  datetimepickerInit($('.datetimepicker'));

  //confirm alert before delete
  $(".delete-btn").click(function (e) {
    e.preventDefault();
    var r = confirm("Are you sure?");
    if (r) {
      $(this).closest("form").submit();
    } else {
      return false;
    }
  });

  //max length indicator for textarea within .form-group
  $(".form-group .maxlength-indicator").each(function () {
    var $indicator = $(this);
    var $textarea = $(this).parent().find("textarea");
    var maxLength = $textarea.attr("maxlength");

    //onload
    $indicator.text(maxLength - $(this).val().length);

    //onchange
    $textarea.on("keyup", function () {
      $indicator.text(maxLength - $(this).val().length);
      //console.log(maxLength - $(this).val().length);
    });
  });

  //Publish content
  $("#approve-pending").click(function (event) {
    var base_url = window.location.protocol + "//" + window.location.host + "/";
    //console.log(base_url);
  });

  parseMarkdown();
  /*
		User Availability
	*/

  $(document).on("click", "#update-roster-availability", function (event) {
    event.preventDefault();
    var _token = $('input[name="_token"]').val();
    var date = $("#date").val();
    date = new Date(date).getTime() / 1000;

    $.ajax({
      method: "GET",
      url: "/admin/users/availability/" + kernel.user_id + "/refresh/",
      data: { _token: _token, date: date },
    })
      .done(function (data) {
        //refresh
        console.log(data);
        if (data.res.success == true) {
          console.log(data.res.data);
        } else {
          console.log(data);
        }
      })
      .fail(function (err) {
        console.log(err.responseText);
      });
  });

  //report
  $("#individual-report").click(function (event) {
    event.preventDefault();

    let user_id = $(this).data("userId");

    $.confirm({
      title: "Individual Roster",
      theme: "custom small",
      closeIcon: true,
      animateFromElement: false,
      content:
        "" +
        '<div class="fifty-fifty-wrapper product-edit-forms no-margin">' +
        '<div class="form-group">' +
        '<form target="_blank" id="form-individual-report" action="/admin/report/individual-roster/' +
        user_id +
        '"' +
        ' class="">' +
        '<div class="gr-row">' +
        '<div class="gr-column-50">' +
        '<label for="start_date" class="block-label">From <span class="required-indicator">*</span></label>' +
        '<input type="text" name="start_date" id="start-date" class="datepicker form-control" placeholder="None" readonly="readonly" required />' +
        "</div>" +
        '<div class="gr-column-50">' +
        '<label for="end_date" class="block-label">To <span class="required-indicator">*</span></label>' +
        '<input type="text" name="end_date" id="end-date" class="datepicker form-control" readonly="readonly" placeholder="None" />' +
        "</div>" +
        "</div>" +
        "</div>" +
        "</div>" +
        "</form>",
      buttons: {
        create: {
          text: "Create",
          btnClass: "button-primary",
          action: function () {
            let endDate = $("#end-date").datepicker("getDate");
            let startDate = $("#start-date").datepicker("getDate");

            if (endDate != null && startDate != null) {
              $("#form-individual-report").submit();
            } else {
              return false;
            }
          },
        },
        cancel: {
          text: "Cancel",
          btnClass: "button-default",
          cancel: function () {},
        },
      },
      onOpen: function () {
        // before the modal is displayed.
        $(".datepicker").datepicker({
          dateFormat: "dd M yy",
        });
      },
    });
  });

  $("#stand-by-report").click(function (event) {
    event.preventDefault();

    let user_id = $(this).data("userId");

    $.confirm({
      title: "Stand-by Report",
      theme: "custom small",
      closeIcon: true,
      animateFromElement: false,
      content:
        "" +
        '<form target="_blank" id="form-stand-by-report" action="/admin/report/stand-by" class="clone-incident">' +
        // '<label for="title">From<span class="required-indicator">*</span></label>' +
        // '<input type="text" name="from-date" id="from-date" class="datepicker"/>' +
        // '<label for="to-date">To</label>' +
        // '<input type="text" name="to-date" id="to-date" class="datepicker"/>' +
        '<div class="gr-row">' +
        '<div class="gr-column-50">' +
        '<label for="start_date" class="block-label">From <span class="required-indicator">*</span></label>' +
        '<input type="text" name="start_date" id="start-date" class="datepicker form-control" placeholder="None" readonly="readonly" required />' +
        "</div>" +
        '<div class="gr-column-50">' +
        '<label for="end_date" class="block-label">To <span class="required-indicator">*</span></label>' +
        '<input type="text" name="end_date" id="end-date" class="datepicker form-control" readonly="readonly"  placeholder="None" />' +
        "</div>" +
        "</div>" +
        "</form>",
      buttons: {
        create: {
          text: "Create",
          btnClass: "button-primary",
          action: function () {
            let endDate = $("#end-date").datepicker("getDate");
            let startDate = $("#start-date").datepicker("getDate");

            if (endDate != null && startDate != null) {
              $("#form-stand-by-report").submit();
            } else {
              return false;
            }
          },
        },
        cancel: {
          text: "Cancel",
          btnClass: "button-default",
          cancel: function () {},
        },
      },
      onOpen: function () {
        // before the modal is displayed.
        $("#start-date").datepicker({
          dateFormat: "dd M yy",
          onSelect: function (dateText, inst) {
            let endDate = $("#end-date").datepicker("getDate");
            let startDate = $("#start-date").datepicker("getDate");

            let maxAllowedNumberOfDays = 14;
            let allowedDates = generateAllowedDates(
              startDate,
              maxAllowedNumberOfDays
            );
            if (endDate != null) {
              dmy =
                endDate.getDate() +
                "-" +
                (endDate.getMonth() + 1) +
                "-" +
                endDate.getFullYear();
              if ($.inArray(dmy, allowedDates) == -1) {
                $("#end-date").datepicker("setDate", null);
              }
            }
          },
        });

        $("#end-date").datepicker({
          beforeShowDay: function (dt) {
            return [isDateEnabled(dt), ""];
          },
          dateFormat: "dd M yy",
        });
      },
    });
  });

  //Alert for Export CSV
  $(".export-csv-trigger").on("click", function (event) {
    event.preventDefault();
    $(".buttons-csv").click();
    alertRequestWait();
  });

  $("#print-plan").click(function (event) {
    event.preventDefault();

    let incident_id = $(this).data("incidentId");
    let reportLocation = "/admin/report/incident-plan/" + incident_id;
    window.open(reportLocation, "_blank");
  });

  $("#roster-export").click(function (event) {
    alertRequestWait();

    let incident_id = $(this).data("incidentId");
    let exportLocation =
      "/admin/report/export-incident-plan/" + incident_id + "?format=word";

    var link = document.createElement("a");
    link.href = exportLocation;
    link.click();
  });

  $("#print-meal").click(function (event) {
    event.preventDefault();
    let incident_id = $(this).data("incidentId");
    let reportLocation = "/admin/report/incident-meal/" + incident_id;
    window.open(reportLocation, "_blank");
  });

  $("#event-print-meal").click(function (event) {
    event.preventDefault();
    let incident_id = $(this).data("incidentId");
    let reportLocation = "/admin/report/event-meal/" + incident_id;
    window.open(reportLocation, "_blank");
  });

  if ($("#operation").data("operation") == "create") {
    $(".email").hide();
    $(".template").hide();
    $(".template-form").hide();
    $(".default-send-to").hide();
  }

  $('#roster-print').on("click",(e) => {
    e.preventDefault();
    e.stopPropagation();
  
    document.title = $('h2.page-title').text();
    window.print();
  });

  $("#resource-list-print").on("click", (e) => {
    e.preventDefault();
    e.stopPropagation();

    window.open(
      "/admin/report/export-resource-list/" + $("#resource-list-print").data('uuid'),
      "_blank" // Open in a new window.
    );

    //Various configurations for ajax always corrupted the excel when a request launched through inspector worked fine
    // $.ajax({
    //   method: "GET",
    //   url: "/admin/report/export-resource-list/" + "1234",
    //   headers: {
    //     "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    //     Accept: "application/octet-stream",
    //   },
    //   xhrFields: { responseType: "blob" },
    // //   success: function (response) {
    // //     var blob = new Blob([response], { type: 'application/octet-stream' });
    // //     var link = document.createElement('a');
    // //     link.href = URL.createObjectURL(blob);
    // //     link.download = 'filename.xlsx';
    // //     document.body.appendChild(link);
    // //     link.click();
    // //     document.body.removeChild(link);
    // // },
    // })/* .done((data) => {
    //   var blob = new Blob([data], { type: "application/octet-stream" });
    //   var link = document.createElement("a");
    //   link.href = window.URL.createObjectURL(blob);
    //   link.download = "resource_list.xlsx";
    //   link.click();
    // }) */;
  });

 

  // //component mode
  // $(document).on('change', '#content_mode_component', function() {

  // 	$.event.trigger({
  // 		type: "content_mode_component_change",
  // 		value: this.value,
  // 		trigger_component: "content_mode_component"
  // 	});

  // });

  // //component mode
  // $(document).on("content_mode_component_change", function(event){

  // 	event.catch_component = "content_send_to_component";

  // 	var settings = {
  // 		"url": "/admin/addon-request",
  // 		"method": "GET",
  // 		"data": {
  // 			"type": event.type + "_" + event.value,
  // 			"value": event.value,
  // 			"trigger_component": event.trigger_component,
  // 			"catch_component": event.catch_component,
  // 			"message_id": $("#message_id").val()
  // 		}
  // 	};

  // 	$.ajax(settings).done(function (response) {

  // 		sendTo = $(".product-send-to .edit");
  // 		sendTo.html(response.result)

  // 		sendTo.find('select').select2({
  // 			placeholder: "Select User Groups",
  // 		});

  // 		$(".email").show();
  // 		$(".template").show();
  // 		$(".default-send-to").show();
  // 		$(".template-form").show();

  // 		$("#title").prop('disabled', true);
  // 		$("#body").prop('disabled', true);

  // 	}).fail(function(err){

  // 		console.log(err);

  // 	});
  // });

  // //remove. find better way
  // if($("#content_send_to_component").is(":visible")){

  // 	$(".template-form").show();
  // }

  // $(document).on('change', '#content_send_to_component', function() {

  // 	var component = $("#content_mode_component").val();
  // 	if($("#content_template_component").val() !== "general" && component !== "user_group"){
  // 		$( "#content_template_component" ).trigger( "change" );
  // 	}

  // });

  // //template
  // $(document).on("content_mode_component_change", function(event){

  // 	event.catch_component = "content_template_component";

  // 	var settings = {
  // 		"url": "/admin/addon-request",
  // 		"method": "GET",
  // 		"data": {
  // 			"type": "event.mode.change.template" + "." + event.value,
  // 			"value": event.value,
  // 			"trigger_component": event.trigger_component,
  // 			"catch_component": event.catch_component,
  // 			"message_id": $("#message_id").val()
  // 		}
  // 	};

  // 	$.ajax(settings).done(function (response) {

  // 		template = $(".template");
  // 		template.html(response.result);
  // 		$("#content_send_to_component").addClass("send-incident");
  // 		$( "#content_template_component" ).trigger( "change" );

  // 	}).fail(function(err){

  // 		console.log(err);

  // 	});
  // });

  // //This should move into communications
  // //for now hard-code data
  // $(document).on('change', '#content_template_component', function() {

  // 		$.event.trigger({
  // 			type: "content_template_component_change",
  // 			value: this.value,
  // 			trigger_component: "content_template_component"
  // 		});

  // });

  // //on template change
  // $(document).on("content_template_component_change", function(event){

  // 	setTimeout(function(){
  // 		event.catch_component = "content_template_component";
  // 			event.extra = {
  // 				"send_to": $("#content_send_to_component").val()
  // 			}
  // 			var settings = {
  // 				"url": "/admin/addon-request",
  // 				"method": "GET",
  // 				"data": {
  // 					"type": "event.template.change" + "." + event.value,
  // 					"value": event.value,
  // 					"trigger_component": event.trigger_component,
  // 					"catch_component": event.catch_component,
  // 					"extra": event.extra
  // 				}
  // 			}

  // 			$(".template-form").show();
  // 			$.ajax(settings).done(function (response) {

  // 				var title = response.result.subject;
  // 				var body = response.result.body;

  // 				$("#title").val(title);
  // 				$("#body").val(body);

  // 				$("#title").prop('disabled', false);
  // 				$("#body").prop('disabled', false);
  // 			}).fail(function(err){
  // 				console.log(err);

  // 			});
  // 	}, 1500, event);

  // })

  ReadOnlyMode();

  //IMT ROLE CATEGORY

  $("#is_incident_controller").change(function () {
    let currentSelectedValue = $("#is_incident_controller").is(":checked");
    $("#parent_group_id_role_group").find("option").remove();

    if (currentSelectedValue == true) {
      $("#parent_group_id_role_group").parent().hide();
    } else {
      $("#parent_group_id_role_group").parent().show();
    }
  });

  $("#is_incident_controller").trigger("change");

  $("#parent_group_id_category").change(function () {
    let currentSelectedValue = $(this).val();
    if ($("#parent_group_id_role_group").is(":visible")) {
      var settings = {
        url: "/admin/imt/role-group",
        method: "GET",
        data: {
          role_category_id: currentSelectedValue,
        },
      };

      $.ajax(settings)
        .done(function (response) {
          $("#parent_group_id_role_group").find("option").remove();
          var list = response.data.list;

          Object.keys(list).forEach(function (index) {
            var newOption = new Option(list[index], index, false, false);
            $("#parent_group_id_role_group")
              .append(newOption)
              .trigger("change");
          });
        })
        .fail(function (err) {
          console.log(err);
        });
    } else {
      $("#parent_group_id_role_group").find("option").remove();
    }
  });

  //SYSTEM COLOURS

  $(".colour-select").change(function () {
    let currentSelectedText = $(".colour-select option:selected").text();
    let color = currentSelectedText.split("-");
    let isValidColor;
    if (color.length == 1) {
      color = color[0].trim();
      isValidColor = /^#[0-9A-F]{6}$/i.test(color);
    } else {
      color = color[1].trim();
      isValidColor = /^#[0-9A-F]{6}$/i.test(color);
    }

    if (isValidColor) {
      $(".colour-chosen").css("background-color", color);
    } else {
      $(".colour-chosen").css("background-color", "");
    }
  });

  $(".colour-select").trigger("change");

  userWorkHoursInit();
});

$(".colour-selection").on("change", function() {
  let currentSelectedText = $(".colour-selection option:selected").val();
  $("#colour-chosen").removeClass();
  $("#colour-chosen").addClass(currentSelectedText);
});

$(".colour-selection").trigger("change");

async function replaceSubview(selector, srcUrl) {
  const subView = $(selector);

  return new Promise((resolve) => {
    $.ajax({
      url: srcUrl,
      method: "GET",
    }).then((res) => {
      subView.replaceWith(res);
      resolve();
    });
  });
}

//User Work Hours Input - bind listeners
async function userWorkHoursInit() {
  const $workHoursContainer = $("#work-hours-container");
  if ($workHoursContainer.length === 0) return;

  const $form = $(".user-form");
  const $edit = $("#enable-edit-work-hours");
  const $table = $("#default-work-hours-table");
  const $tbody = $("#default-work-hours-table tbody");
  const $currentWorkHoursRow = $(".current-work-hours-row");
  const $workHoursRow = $(".work-hours-row");
  const $addWorkHoursButton = $("#add-work-hours");
  const $apply = $("#apply-work-hours");
  const $cancel = $("#cancel-work-hours");

  const userId = $("#user-uuid").val();

  const Format = "d M yy";

  let currentWorkHours = {}; //Existing work hours, id as key
  let addWorkHours = {}; //New work hours, index as key
  /**
   *
   * @param {JQueryElement} jqueryRow
   * @param {JQueryElement} jqueryHours
   * @param {JQueryElement} jqueryFrom
   * @param {JQueryElement} jqueryTo
   * @param {number} hours
   * @param {Date} start
   * @param {Date|null} end
   * @param {boolean} isChanged isChanged, reset on apply/cancel
   * @param {boolean} isDeleted isDeleted, reset on apply/cancel
   * @param {Date|null} confirmedHours isDeleted, reset on apply/cancel
   * @param {Date|null} confirmedStart isDeleted, reset on apply/cancel
   * @param {Date|null} confirmedEnd isDeleted, reset on apply/cancel
   * @returns
   */
  function createWorkHours(
    jqueryRow,
    jqueryHours,
    jqueryFrom,
    jqueryTo,
    hours,
    start,
    end,
    isChanged = false,
    isDeleted = false,
    confirmedHours = null,
    confirmedStart = null,
    confirmedEnd = null
  ) {
    return {
      $: {
        row: jqueryRow,
        hours: jqueryHours,
        from: jqueryFrom,
        to: jqueryTo,
      },
      hours: hours,
      confirmedHours: confirmedHours,
      start: start,
      confirmedStart: confirmedStart,
      end: end,
      confirmedEnd: confirmedEnd,
      isChanged: isChanged,
      isDeleted: isDeleted
    };
  }

  //Add
  $addWorkHoursButton.click(function () {
    $addWorkHoursButton.toggleClass("hidden", true);
    createFromClone(true);
  });

  //Init current work hours
  $currentWorkHoursRow.each(function (index, $ele) {
    setRowDatePickers($($ele), false);
  });

  let currentNewId = 0;
  /**
   * Set Row Date Pickers
   * @param {jQueryElement} $row Element to apply listeners on
   * @param {boolean} isNew Doesn't exist in database
   * @param {idKey} withExistingId id to fetch initial data from
   */
  function setRowDatePickers($row, isNew, withExistingId = null) {
    const $hours = $row.find(".default-work-hours");
    const $from = $row.find(".work-hours-from");
    const $to = $row.find(".work-hours-to");
    $from.addClass("datepicker");
    $to.addClass("datepicker");

    const rowData = isNew ? addWorkHours : currentWorkHours;

    //set id
    let id;
    if (withExistingId !== null) {
      id = withExistingId;
      //Update references
      rowData[id].$.row = $row;
      rowData[id].$.hours = $hours;
      rowData[id].$.from = $from;
      rowData[id].$.to = $to;
    } else if (isNew) {
      id = currentNewId++;
    } else id = $row.attr("data-id");

    //init remove button
    if (isNew) {
      //Cancel
      $row.find(".cancel-add-work-hours").click(function () {
        if (addWorkHours[id] !== undefined) {
          addWorkHours[id].isDeleted = true;
          setNullDates(false);
        } else $addWorkHoursButton.toggleClass("hidden", false); //Show button if from date not picked before delete
        $row.remove();
        toggleTableIfEmpty();
        setNullDates(false);
      });
    } else {
      //Delete
      $row.find(".delete-scheduled-work-hours").click(function () {
        currentWorkHours[id].isDeleted = true;
        setNullDates(false);
        currentWorkHours[id].deleteUrl = $row
          .find(".delete-scheduled-work-hours")
          .attr("data-url");
        $row.remove();
        toggleTableIfEmpty();
      });
    }

    //Hours
    $hours.change(function () {
      if (isNew && rowData[id] === undefined) return;
      const val = $hours.val();
      if (val !== rowData[id].confirmedHours) {
        rowData[id].hours = val;
        rowData[id].isChanged = true;
      }
    });

    //From
    $from.datepicker({
      dateFormat: Format,
      beforeShowDay: (date) => noOverlap(date, id, isNew),
      beforeShow: () => fromBeforeShow($to),
      onSelect: function (dateText, dateInst) {
        const val = new Date(dateText);
        alertIfBeforeToday(val);
        if (isNew && addWorkHours[id] === undefined) {
          //First save
          const workHours = $hours.val();
          addWorkHours[id] = createWorkHours(
            $row,
            $hours,
            $from,
            $to,
            workHours,
            val,
            null,
            false,
            false
          );
          insertRowInOrder($row, val);
          setNullDates(false);

          //Enable end date/add new
          $to.prop("disabled", false);
          $addWorkHoursButton.toggleClass("hidden", false);
        } else if (val !== rowData[id].confirmedStart) {
          rowData[id].start = val;
          rowData[id].isChanged = true;
          if (rowData[id].end === null) {
            //Can rearrange
            insertRowInOrder($row, rowData[id].start);
            setNullDates(false);
          }
        }
      },
    });

    //To
    $to.datepicker({
      dateFormat: Format,
      beforeShow: () => toBeforeShow($from, $to, id, isNew),
      closeText: "Clear",
      onSelect: function (dateText, dateInst) {
        const val = new Date(dateText);
        alertIfBeforeToday(val);
        if (val !== rowData[id].confirmedEnd) {
          rowData[id].end = val;
          rowData[id].isChanged = true;
          $to.toggleClass("indefinite-date", false);
        }
      },
    });

    if(!isNew && !withExistingId){
      //Store initial state of table rows
      const hoursVal = $hours.val();
      const fromVal = $from.datepicker("getDate");
      const toVal = $to.datepicker("getDate");

        currentWorkHours[id] = createWorkHours(
          $row,
          $hours,
          $from,
          $to,
          hoursVal,
          fromVal,
          toVal,
          false,
          false,
          hoursVal,
          fromVal,
          toVal
        );
    }

    //Datepicker before show for "from"
    function fromBeforeShow($to) {
      let modObj = {};

      const toVal = $to.datepicker("getDate");
      if (toVal !== null && !$to.hasClass("indefinite-date")) {
        modObj.maxDate = toVal;
        const prevEndDate = getPreviousEndDate(toVal);
        modObj.minDate =
          prevEndDate === null ? addDays(prevEndDate, 1) : null;
      } else {
        //reset - free to place
        modObj.minDate = null;
        modObj.maxDate = null;
      }

      return modObj;
    }

    function toBeforeShow($from, $to, id) {
      let modObj = {};      

      const fromVal = $from.datepicker("getDate");
      modObj.minDate = fromVal;
      const nextStart = getNextStartDate(fromVal);
      modObj.maxDate = nextStart === null ? null : addDays(nextStart, -1);

      const nullEnd = rowData[id].end === null;
      $to.datepicker("option", "showButtonPanel", !nullEnd); //Needs to execute before listener attached
      if (!nullEnd) {
        //Add clear button on next page update
        setTimeout(() => {
          $(".ui-datepicker-close").click(function () {
            rowData[id].end = null;
            rowData[id].isChanged = true;
            setNullDates(false);
          });
        });
      }

      return modObj;
    }

    //For beforeShowDay
    function noOverlap(date, id, isNew) {
      let isValid = true;
      for (const hoursId in currentWorkHours) {
        if (!isNew && id == hoursId) continue;
        const inst = currentWorkHours[hoursId];
        if (inst.isDeleted) continue;
        const instEnd = inst.end === null ? inst.start : inst.end;
        if (inst.start <= date && instEnd >= date) {
          isValid = false;
          break;
        }
      }
      if (isValid) {
        for (const hoursId in addWorkHours) {
          if (isNew && id == hoursId) continue;
          const inst = addWorkHours[hoursId];
          if (inst.isDeleted) continue;
          const instEnd = inst.end === null ? inst.start : inst.end;
          if (
            (inst.start <= date && instEnd >= date) ||
            date == inst.start ||
            date == instEnd
          ) {
            isValid = false;
            break;
          }
        }
      }

      return [isValid, ""];
    }
  }

  function toggleTableIfEmpty() {
    //Timeout allows the page to update before selecting
    setTimeout(() => {
      if ($tbody.children().not(".hidden").length === 0) {
        $table.toggleClass("hidden", true);
      }
    });
  }

  //Enable Edit
  let isEditing = false;
  $edit.click(toggleEditing);

  //Apply current
  $apply.click(async function () {
    clearEmptyRows();
    setNullDates(true);
    if (userId !== undefined) {
      //Updates and stores
      let actionQueue = [];

      for (const hoursId in currentWorkHours) {
        const inst = currentWorkHours[hoursId];
        if (inst.isDeleted == true) {
          actionQueue.push(deleteWorkHours(hoursId, inst.deleteUrl));
        } else if (inst.isChanged) {
          actionQueue.push(
            updateWorkHours(hoursId, {
              hours: inst.hours,
              start: inst.start,
              end: inst.end,
            })
          );
        }
      }
      for (const hoursId in addWorkHours) {
        const inst = addWorkHours[hoursId];
        if (inst.isDeleted) {
          delete addWorkHours[hoursId];
        } else
          actionQueue.push(
            storeWorkHours(hoursId, {
              user: userId,
              hours: inst.hours,
              start: inst.start,
              end: inst.end,
            })
          );
      }

      function storeWorkHours(id, body) {
        const storeUrl = $(".work-hours-row").attr("data-url");
        return new Promise((resolve, reject) =>
          $.ajax({
            url: storeUrl,
            method: "POST",
            data: body,
          })
            .done((response) => {
              const inst = addWorkHours[id];
              currentWorkHours[response] = createWorkHours(
                inst.$.row,
                inst.$.hours,
                inst.$.from,
                inst.$.to,
                inst.hours,
                inst.start,
                inst.end,
                false,
                false
              );

              delete addWorkHours[id];
              newToCurrent(currentWorkHours[response].$.row, response);
              resolve();
            })
            .fail(() => reject())
        );
      }

      function updateWorkHours(id, body) {
        const updateUrl = currentWorkHours[id].$.row.attr("data-url");
        return new Promise((resolve, reject) =>
          $.ajax({
            url: updateUrl,
            method: "PUT",
            data: body,
          })
            .done(() => {
              currentWorkHours[id].isChanged = false;
              resolve();
            })
            .fail(() => reject())
        );
      }

      function deleteWorkHours(id, deleteWHUrl) {
        return new Promise((resolve, reject) =>
          $.ajax({
            url: deleteWHUrl,
            method: "DELETE",
          })
            .done(() => {
              delete currentWorkHours[id];
              resolve();
            })
            .fail(() => reject())
        );
      }

      await Promise.all(actionQueue);
      for (const hoursId in currentWorkHours) {
        currentWorkHours[hoursId].confirmedHours =
          currentWorkHours[hoursId].hours;
        currentWorkHours[hoursId].confirmedStart =
          currentWorkHours[hoursId].start;
        currentWorkHours[hoursId].confirmedEnd = currentWorkHours[hoursId].end;
      }
    } else {
      for (const id in addWorkHours) {
        if (addWorkHours[id].isDeleted) delete addWorkHours[id];
        else {
          addWorkHours[id].confirmedHours = addWorkHours[id].hours;
          addWorkHours[id].confirmedStart = addWorkHours[id].start;
          addWorkHours[id].confirmedEnd = addWorkHours[id].end;
          addWorkHours[id].isChanged = true;
        }
      }
    }
    toggleEditing();
  });

  //Cancel - apply prev
  $cancel.click(function () {
    clearEmptyRows();
    if (userId === undefined) {
      //Revert new
      for (const hoursId in addWorkHours) {
        //Remove new
        if (addWorkHours[hoursId].confirmedHours === null) {
          addWorkHours[hoursId].$.row.remove();
          delete addWorkHours[hoursId];
        } else {
          undoChanges(true, hoursId);
        }
      }
    } else {
      //Discard new
      for (const hoursId in addWorkHours) {
        addWorkHours[hoursId].$.row.remove();
        delete addWorkHours[hoursId];
      }
      //Revert changed
      for (const hoursId in currentWorkHours) {
        undoChanges(false, hoursId);
      }
    }

    function undoChanges(isNew, id) {
      const rowDataObj = isNew ? addWorkHours : currentWorkHours;
      const data = rowDataObj[id];
      if (data.isDeleted) {
        data.isDeleted = false;
        createFromClone(isNew, id);
      }
      if (data.isChanged) {
        data.isChanged = false;
        //Overwrite row
        const $ = data.$;
        //Hours
        $.hours.val(data.confirmedHours);
        data.hours = data.confirmedHours;
        //From
        $.from.datepicker("setDate", data.confirmedStart);
        data.start = data.confirmedStart;
        //To
        $.to.datepicker("setDate", data.confirmedEnd);
        data.end = data.confirmedEnd;

        insertRowInOrder($.row, data.start);
      }
    }

    toggleTableIfEmpty();
    toggleEditing();
    setNullDates(true);
  });

  function clearEmptyRows() {
    //Clear empty
    $(".work-hours-row")
      .not(".hidden")
      .filter((index, element) => {
        const $row = $(element);
        const $from = $row.find(".work-hours-from");
        return $from.datepicker("getDate") === null;
      })
      .remove();
    toggleTableIfEmpty();
  }

  //Toggle hides and disables based on isEditing toggling
  function toggleEditing() {
    isEditing = !isEditing;
    $edit.toggleClass("hidden", isEditing);
    $apply.toggleClass("hidden", !isEditing);
    $cancel.toggleClass("hidden", !isEditing);

    $tbody
      .find("input")
      .not($workHoursRow.find(".work-hours-to")) //initial add work hours for cloning
      .prop("disabled", !isEditing);
    $tbody.find("button").toggleClass("hidden", !isEditing);

    $addWorkHoursButton.toggleClass("hidden", !isEditing);
  }

  /**
   * Returns the next default hours' start or null if there is none
   * @param {Date} date
   * @returns {Date||null}
   */
  function getNextStartDate(date) {
    let min = null;
    for (const currentHours in currentWorkHours) {
      const inst = currentWorkHours[currentHours];
      if (inst.isDeleted) continue;
      if (inst.start > date) {
        if (min === null || min > inst.start) min = inst.start;
      }
    }
    for (const newHours in addWorkHours) {
      const inst = addWorkHours[newHours];
      if (inst.isDeleted) continue;
      if (inst.start > date) {
        if (min === null || min > inst.start) min = inst.start;
      }
    }
    return min;
  }

  /**
   * Returns the previous default hours' end/(start date + 1 if null) or null if there is none
   * @param {Date} date
   * @returns {Date||null}
   */
  function getPreviousEndDate(date) {
    let max = null;
    for (const currentHours in currentWorkHours) {
      const inst = currentWorkHours[currentHours];
      if (inst.isDeleted) continue;
      const instEnd = inst.end === null ? addDays(inst.start, 1) : inst.end;
      if (instEnd < date) {
        if (max === null || max < instEnd) max = instEnd;
      }
    }
    for (const newHours in addWorkHours) {
      const inst = addWorkHours[newHours];
      if (inst.isDeleted) continue;
      const instEnd = inst.end === null ? addDays(inst.start, 1) : inst.end;
      if (instEnd < date) {
        if (max === null || max < instEnd) max = instEnd;
      }
    }
    return max;
  }

  //Insert a row in the correct position of the table
  function insertRowInOrder($row, date) {
    const nextStart = getNextStartDate(date);
    let $beforeEle = null;
    for (const hoursId in currentWorkHours) {
      if (currentWorkHours[hoursId].start == nextStart) {
        $beforeEle = currentWorkHours[hoursId].$.row;
        break;
      }
    }
    if ($beforeEle == null) {
      for (const hoursId in addWorkHours) {
        if (addWorkHours[hoursId].start == nextStart) {
          $beforeEle = addWorkHours[hoursId].$.row;
          break;
        }
      }
    }
    if ($beforeEle == null) $row.appendTo($tbody);
    else $row.insertBefore($beforeEle);
  }

  function setNullDates(changeData) {
    for (const hoursId in currentWorkHours) {
      const data = currentWorkHours[hoursId];
      const nextStart = getNextStartDate(data.start);
      if (data.end === null) {
        const endDate = nextStart === null ? null : addDays(nextStart, -1);
        data.$.to.datepicker("setDate", endDate);
        data.$.to.toggleClass("indefinite-date", !changeData);
        if (changeData && endDate !== null) {
          currentWorkHours[hoursId].end = endDate;
          currentWorkHours[hoursId].isChanged = true;
        }
      } else data.$.to.toggleClass("indefinite-date", false);
    }

    for (const hoursId in addWorkHours) {
      const data = addWorkHours[hoursId];
      const nextStart = getNextStartDate(data.start);
      if (data.end === null) {
        const endDate = nextStart === null ? null : addDays(nextStart, -1);
        data.$.to.datepicker("setDate", endDate);
        data.$.to.toggleClass("indefinite-date", !changeData);
        if (changeData) addWorkHours[hoursId].end = endDate;
      } else data.$.to.toggleClass("indefinite-date", false);
    }
  }

  //Add/Remove days to a date
  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function alertIfBeforeToday(date) {
    // Dates are from midnight so a 24 hour comparison suffices
    if (date < new Date() - 24 * 60 * 60 * 1000)
      $.alert({
        theme: "custom",
        title: "Are you sure?",
        animateFromElement: false,
        content: //James popup essay here
          "You have selected a date in the past. The number of hours you entered will replace the value for each day within the set date period. This action is not easily reversible once saved. You will need to manually edit each days work hours using the workforce roster popup to change",
        scrollToPreviousElement: false,
        buttons: {
          close: {
            btnClass: "button-primary",
            text: "I Understand",
          },
        },
      });
  }

  //Create and insert a new or existing input set
  function createFromClone(isNew, withExistingId = null) {
    const $newRow = $workHoursRow.clone(false).toggleClass("hidden", false);
    const rowData = isNew ? addWorkHours : currentWorkHours;

    if (withExistingId === null) {
      //Empty add new
      $newRow.appendTo($tbody);
    } else {
      //From existing Data
      if (!isNew) newToCurrent($newRow, withExistingId);
      rowDateInputs($newRow, rowData[withExistingId]);
      insertRowInOrder($newRow, rowData[withExistingId].start);
    }

    //Prefill inputs
    function rowDateInputs($row, data) {
      const momentFormat = "D MMM YYYY";
      const startText =
        data.start === null ? "" : moment(data.start).format(momentFormat);
      const endText =
        data.end === null ? "" : moment(data.end).format(momentFormat);

      $row.find(".default-work-hours").val(data.hours);
      $row.find(".work-hours-from").val(startText);
      $row.find(".work-hours-to").val(endText);
    }

    $table.toggleClass("hidden", false);
    setRowDatePickers($newRow, isNew, withExistingId);
  }

  //Convert a addWorkHours row to currentWorkHours row
  function newToCurrent($row, id) {
    const newUrl = $row.attr("data-url") + "/" + id;
    $row
      .removeClass("work-hours-row")
      .addClass("current-work-hours-row")
      .attr("data-url", newUrl)
      .attr("data-id", id);

    $row.find(".work-hours-to").prop("disabled", false);

    let deleteBtn = $row.find(".cancel-add-work-hours");
    deleteBtn
      .removeClass("cancel-add-work-hours")
      .addClass("delete-scheduled-work-hours hidden")
      .attr("data-url", newUrl);
  }

  //Form bind
  document.querySelector('.user-form').addEventListener('formdata', function(e){
    if (userId === undefined) {
      //Store only
      const formData = e.formData;

      const formObject = [];
        for (const index in addWorkHours) {
          const inst = addWorkHours[index];
          if (inst.confirmedHours !== null) {
            formObject.push({
              hours: inst.confirmedHours,
              start: inst.confirmedStart,
              end: inst.confirmedEnd,
            });
          }
        }

      formData.set('default_work_hours', JSON.stringify(formObject));
    }
  });
}

//Datetimepicker init
function datetimepickerInit($jqueryObjects) {
  let dateNonNullValues = [];
  $jqueryObjects.each((index, element) => {
    const $ele = $(element);
    const $datepicker = $ele.find('.datepicker');
    const $none = $ele.find('.null-datetime-checkbox');

    $none.change((e)=>nullDatepicker(e, $datepicker, index));
    if($none.prop('checked'))$none.trigger('change');
    timepickerInit($ele.find('.datetimepicker-time'), $none);
  });

  function nullDatepicker(e, $datepicker, dateIndex){
    const isChecked = e.target.checked;
    $datepicker.toggleClass('hidden', isChecked);
    if(isChecked){
      dateNonNullValues[dateIndex] = $datepicker.datepicker('getDate');
      $datepicker.datepicker('setDate', null);
    } else {
      $datepicker.datepicker('setDate', dateNonNullValues[dateIndex] ); 
    }
       
  }
}

//Timepicker init
function timepickerInit($jqueryObjects, noneCheckboxJqueryElement = null) {
  $jqueryObjects.each((index, element) => {
    //Jquery not used since it can't bypass disabled
    const $hours = element.querySelector(".hours");
    const $minutes = element.querySelector(".minutes");
    const $meridian = element.querySelector(".meridian");
    const $output = element.querySelector(".time-output");
    const type = $output.dataset.format;
    let includeMeridian;
    switch (type) {
      case "24":
        includeMeridian = false;
        break;
      case "12":
        includeMeridian = true;
    }

    //Prefill if timepicker has a value
    if ($output.value !== "") {
      const time = new Date($output.value);
      const hours = time.getHours();
      const minutes = time.getMinutes();
      const pm = hours >= 12;

      switch (type) {
        case "24":
         $($hours).select2("val", hours);

          // $hours.value = hours;
          break;
        case "12":
          const hours12 = hours + 12;
          $($hours).select2("val", hours12 % 12 == 0 ? 12 : hours12 % 12);
          
          break;
      }

      const minutesFormat = minutes < 10 ? "0" + minutes : minutes;
      
      $($minutes).select2("val", minutesFormat);
      if (includeMeridian) {
        $($minumeridiantes).select2("val", pm ? "pm" : "am");
      }
    }
    updateOutput(noneCheckboxJqueryElement); //Set prefill data

    //Hidden field updates
    if (noneCheckboxJqueryElement !== null)
      noneCheckboxJqueryElement.change(()=>updateOutput(noneCheckboxJqueryElement));

      $(document.body).on("change",".hours",function(){
        updateOutput(noneCheckboxJqueryElement);
      });

      $(document.body).on("change",".minutes",function(){
        updateOutput(noneCheckboxJqueryElement);
      });
      if (includeMeridian){
        $(document.body).on("change",".meridian",function(){
          updateOutput(noneCheckboxJqueryElement);
        });
      } 

    // $hours.addEventListener("change", () =>
    
    //   updateOutput(noneCheckboxJqueryElement)
    // );
    // $minutes.addEventListener("change", () =>
    //   updateOutput(noneCheckboxJqueryElement)
    // );
    // if (includeMeridian)
    //   $meridian.addEventListener("change", () =>
    //     updateOutput(noneCheckboxJqueryElement)
    //   );

    function updateOutput(checkBoxJquery) {
      
      if (checkBoxJquery !== null && checkBoxJquery.prop("checked")) {
        $output.value = "";
        toggleAll(true);
      } else {
        toggleAll(false);
        $output.value =
          $hours.value +
          ":" +
          $minutes.value +
          (includeMeridian ? $meridian.value : "");
      }

      function toggleAll(hidden) {
        $(element.querySelectorAll(".datetimepicker .select2-container")).toggleClass("hidden", hidden);
        $hours.classList.toggle("hidden", hidden);
        $minutes.classList.toggle("hidden", hidden);
        if (includeMeridian) $meridian.classList.toggle("hidden", hidden);
      }
    }
  });
}

function parseMarkdown() {
  //We have a #content but I think we lost the .content. Can't find it in code or the history I've checked.
  if ($(document).find(".content")) {
    var messageBody = $(".product-body p").html();
    var converter = new showdown.Converter({
        literalMidWordUnderscores: true,
      }),
      text = messageBody,
      html = converter.makeHtml(text);

    $(".product-body").html(html);
  }
}

function ReadOnlyMode() {
  $("form").each(function () {
    if ($(this).data("mode") == "view") {
      $(this).find("td.delete-cell").addClass("remove-cross");
      $(this).find(":input").prop("disabled", true);
      $(this).find(":button").prop("disabled", true);
      $(this).find(":input").addClass("input-disabled");
      $(this).find("textarea").addClass("input-disabled");
      $(".cancel-user-btn").css("display", "none");
      setTimeout(function () {
        $(".select2-container").addClass("input-disabled");
        $(".select2-selection__choice").addClass("input-disabled");
      }, 0);
    }
  });
}

function generateDashedNameFromLevel(level, name) {
  var dash = "";
  for (i = 0; i < level - 1; i++) {
    dash = dash + "-";
  }

  return dash + name;
}

function generateLeveledDropdown(el, group) {
  //var $el = $("#group-role-select");
  //$el.empty(); // remove old options
  //$el.append($("<option></option>").attr("value", "").text("Select Role"));

  for (item in group) {
    var name = "";
    name = generateDashedNameFromLevel(
      group[item]["level"],
      group[item]["name"]
    );
    if (group[item]["disabled"] == true) {
      el.append(
        $("<option disabled='disabled'></option>")
          .attr("value", group[item]["id"])
          .text(name)
      );
    } else {
      el.append(
        $("<option></option>").attr("value", group[item]["id"]).text(name)
      );
    }
  }
}

function isDateEnabled(date) {
  let startDate = $("#start-date").datepicker("getDate");
  let maxAllowedNumberOfDays = 14;
  let allowedDates = [];
  if (startDate == null) {
    return false;
  }

  allowedDates = generateAllowedDates(startDate, maxAllowedNumberOfDays);

  let dmy = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();

  if ($.inArray(dmy, allowedDates) != -1) {
    return true;
  } else {
    return false;
  }
}

function generateAllowedDates(startDate, maxAllowedNumberOfDays) {
  let allowedDates = [];

  var date = startDate;
  allowedDates[0] =
    date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
  for (let index = 1; index < maxAllowedNumberOfDays; index++) {
    date.setDate(date.getDate() + 1);
    allowedDates[index] =
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
  }
  return allowedDates;
}

const audioPlayer = new Plyr("#audio-player");
const videoPlayer = new Plyr("#video-player");
